export enum LanguagesCodes {
  he = "he",
  en = "en",
}

export interface ILanguage {
  name: string;
  code: LanguagesCodes;
  displayName: string;
  direction: "rtl" | "ltr";
}

const languagesConfig: ILanguage[] = [
  {
    name: "english",
    code: LanguagesCodes.en,
    displayName: "English",
    direction: "ltr",
  },
  {
    name: "hebrew",
    code: LanguagesCodes.he,
    displayName: "עברית",
    direction: "rtl",
  },
];

export default languagesConfig;
